import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type SFIconProps = CommonSvgProps

const SFIcon: React.FC<SFIconProps> = React.forwardRef<SVGSVGElement, SFIconProps>((props, ref) => (
  <Svg viewBox="0 0 33 33" {...props} ref={ref} color="none">
    <path
      d="M6.7 10.345c-.15.26-.23.556-.23.857v9.484a1.718 1.718 0 0 0 .858 1.485l8.3 4.742c.26.151.557.23.858.23.36 0 .653.293.653.654 0 .36-.274.746-.635.746-.53 0-1.07-.233-1.529-.498l-8.297-4.741-.002-.002a3.024 3.024 0 0 1-1.512-2.615V11.2c0-.53.14-1.05.405-1.51l1.131.654Z"
      fill="#51565C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.572 9.641a.653.653 0 0 1 .892-.238l10.026 5.8 9.474-5.37a.653.653 0 1 1 .644 1.136l-9.8 5.554a.653.653 0 0 1-.649-.003L5.81 10.534a.653.653 0 0 1-.237-.893Z"
      fill="#51565C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.486 15.29c.36 0 .653.293.653.654v11.95a.653.653 0 1 1-1.306 0v-11.95c0-.36.292-.653.653-.653ZM26.67 9.581c.36 0 .653.292.653.653v11.95a.653.653 0 1 1-1.307 0v-11.95c0-.36.293-.653.654-.653Z"
      fill="#51565C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.089 21.942a.642.642 0 0 1-.233.878l-10.083 5.666c-.304.17-.68-.004-.855-.32a.642.642 0 0 1 .233-.877l10.07-5.61a.642.642 0 0 1 .868.263Z"
      fill="#51565C"
    />
    <path
      d="M5.929 9.181a.75.75 0 1 0 .732 1.31l-.732-1.31Zm12.94-5.77a.75.75 0 0 0-.518-.925L11.856.65a.75.75 0 1 0-.408 1.443l5.773 1.632-1.632 5.774a.75.75 0 1 0 1.444.408l1.836-6.496ZM6.66 10.491l11.852-6.63-.732-1.308L5.929 9.18l.732 1.31Z"
      fill="#53A2D9"
    />
  </Svg>
))

SFIcon.propTypes = commonPropTypes
SFIcon.defaultProps = commonDefaultProps

export default SFIcon
